module.exports = __webpack_public_path__ + "img/25.7c27ee81.svg";